(function () {
  const initSliders = () => {
    const sections = document.querySelectorAll('.popular-products-section');

    sections.forEach((section) => {
      const mediaSliders = section.querySelectorAll(
        '.popular-product-slideshow__slider:not(.swiper-initialized)'
      );

      if (mediaSliders.length > 0) {
        const duration = Number(mediaSliders[0].getAttribute('data-duration'));
        let mediaSliderFirst;
        let mediaSliderAll = [];
        const nextBtn = section.querySelector('.swiper-button-next');
        const prevBtn = section.querySelector('.swiper-button-prev');

        mediaSliders.forEach((slider, index) => {
          if (index == 0) {
            mediaSliderFirst = new Swiper(slider, {
              allowTouchMove: slider.classList.contains(
                'popular-product-slideshow__slider_full'
              )
                ? true
                : false,
              slidesPerView: 3.24,
              spaceBetween: 14,
              speed: 1500,
              navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn,
              },
            });
          } else {
            const mediaSlider = new Swiper(slider, {
              allowTouchMove: false,
              slidesPerView: 'auto',
              speed: 1500,
              on: {
                init() {
                  mediaSliderAll.push(this);
                },
              },
            });
          }
        });

        mediaSliderFirst.on('slideChange', function () {
          mediaSliderAll.forEach((slider, index) => {
            if (slider.slides[mediaSliderFirst.activeIndex])
              setTimeout(() => {
                slider.slideTo(mediaSliderFirst.activeIndex);
              }, (index + 1) * 300);
          });
        });
      }
    });
  };

  const initSlidersMobile = () => {
    const sections = document.querySelectorAll('.popular-products-section');

    sections.forEach((section) => {
      const mediaSlider = section.querySelector(
        '.popular-product-slideshow__slider_mobile:not(.swiper-initialized)'
      );

      const nextBtn = section.querySelector('.swiper-button-next');
      const prevBtn = section.querySelector('.swiper-button-prev');

      if (mediaSlider) {
        new Swiper(mediaSlider, {
          slidesPerView: 1,
          speed: 700,
          allowTouchMove: true,
          watchSlidesProgress: true,
          focusableElements: 'input, select, option, textarea, label',
          navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
          },
        });
      }
    });
  };

  const destroySlidersDesktop = () => {
    const mediaSliders = document.querySelectorAll(
      '.popular-product-slideshow__slider'
    );

    mediaSliders.forEach((slider) => {
      if (slider.swiper) {
        slider.swiper.destroy(true, true);
      }
    });
  };

  const destroySlidersMobile = () => {
    const mediaSliders = document.querySelectorAll(
      '.popular-product-slideshow__slider_mobile'
    );

    mediaSliders.forEach((slider) => {
      if (slider.swiper) {
        slider.swiper.destroy(true, true);
      }
    });
  };

  const initSection = () => {
    const sections = document.querySelectorAll('.popular-products-section');

    sections.forEach((section) => {
      const sectionResizeObserver = new ResizeObserver((entries) => {
        const [entry] = entries;

        let mediaSliders = entry.target.querySelectorAll(
          '.popular-product-slideshow__slider'
        );

        if (document.documentElement.clientWidth < 750) {
          console.log('mobile');
          mediaSliders = entry.target.querySelectorAll(
            '.popular-product-slideshow__slider_mobile'
          );
          destroySlidersDesktop();
          initSlidersMobile();
        } else {
          mediaSliders = entry.target.querySelectorAll(
            '.popular-product-slideshow__slider'
          );
          destroySlidersMobile();
          initSliders();
        }
      });

      sectionResizeObserver.observe(section);
    });
  };

  setTimeout(() => {
    initSection();
  }, 100);

  document.addEventListener('shopify:section:load', function () {
    initSection();
  });
})();
